import React, { useContext } from 'react';
import HeaderNavigation from './components/HeaderNavigation';
import { View, Pressable, Text } from 'react-native';
//replace this logo when jpg received
import logo from './logo.avif';
import styled from 'styled-components/native';
import { Link } from 'app/src/utils/routing';
import Search from 'app/src/components/Search';
import secrets from 'app/secrets';
import { useLocation } from 'react-router-dom';
import UserContext from './contexts/UserContext';
import HeaderMobileNavigation from './components/HeaderMobileNavigation';
import colors from './styles/colors';

const HeaderContainer = styled(View)`
  height: 78px;
  padding: 10px;
  background-color: #D9D9D9;
  display: flex;
  z-index: 999999;

  flex-direction: row;
  justify-content: space-between;
  padding-right: 30px;
  @media (max-width: 480px) {
    padding-left: 5%;
    padding-right: 5%;

    > img {
      width: 90%;
    }
  }
`;

const LogoContainer = styled(View)`
  display: flex;
  flex-direction: row;
  position: relative;
`;

const EnvironmentMark = styled(Text)`
  position: absolute;
  left: 140px;
  top: 0px;
  color: #00000060;
  font-size: 46px;
  font-weight: 900;
`;

const logoStyle = {
  height: '100%'
}

const Header = (isLoggedIn) => {
  const { isMobile, screenWidth } = useContext(UserContext);
  const { baseUri } = secrets.api;
  const location = useLocation();
  let env = '';
  if (baseUri.includes('uat') || baseUri.includes('pti-dev')) {
    env = 'UAT';
  } else if (baseUri.includes('localhost')) {
    env = 'DEV';
  }

  const noHeaders = ['clerk', 'auctioneer', 'hud']
  if(isLoggedIn && noHeaders.some(word => location['pathname'].includes(word))) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: screenWidth < 600 ? '120px' : '0px',
        backgroundColor: colors.elGray
      }}
    >
      <HeaderContainer>
        <LogoContainer>
          <Link to={`/`}>
            <img src={logo} alt="Equiplinc" style={logoStyle} />
            <EnvironmentMark>{env}</EnvironmentMark>
          </Link>
        </LogoContainer>
        {isLoggedIn ? (
          <>
            {screenWidth > 600 ?
              <Search /> :
              null
            }
            {isMobile ?
              <HeaderMobileNavigation /> :
              <HeaderNavigation />
            }
          </>
        ) : null
        }
      </HeaderContainer>
      {screenWidth < 600 ?
        <Search /> : null
      }
    </div>
  )
}

export default Header;
